export default "__VITE_ASSET__j5pHHEgA__"